module.exports = __webpack_public_path__ + "static/Unity_Tower_upper_floor_traditional_v2-bbb34b0ceca8a765980e6642b5cea656.png";